import { gql } from '@apollo/client'

export const UPDATE_ORDER_ITEM_METADATA = gql`
  mutation UPDATE_ORDER_ITEM_METADATA($id: Int!, $metadata: Json) {
    updateOneOrderItem(where: { id: $id }, data: { metadata: $metadata }) {
      id
      metadata
    }
  }
`

export const DELETE_ORDER_ITEM = gql`
  mutation DELETE_ORDER_ITEM($id: Int!) {
    deleteOneOrderItem(where: { id: $id }) {
      id
    }
  }
`

export const DELETE_MANY_ORDERS = gql`
  mutation DELETE_MANY_ORDERS($ids: [String!]!) {
    deleteManyOrder(where: { id: { in: $ids } }) {
      count
    }
  }
`

export const GET_ORDERS = gql`
  query GET_ORDERS(
    $searchTerm: String
    $orderBy: [OrderOrderByWithRelationInput!]
    $take: Int
    $skip: Int
    $filters: [OrderWhereInput!]!
  ) {
    findManyOrderCount(
      orderBy: $orderBy
      where: {
        OR: [
          {
            purchased_by: {
              is: { name: { mode: insensitive, contains: $searchTerm } }
            }
          }
          {
            purchased_by: {
              is: { surname: { mode: insensitive, contains: $searchTerm } }
            }
          }
          { order_code: { mode: insensitive, contains: $searchTerm } }
          { order_external_code: { mode: insensitive, contains: $searchTerm } }
          { company_name: { mode: insensitive, contains: $searchTerm } }
          { invoice_code: { mode: insensitive, contains: $searchTerm } }
        ]
        AND: $filters
      }
    )
    findManyOrder(
      orderBy: $orderBy
      where: {
        OR: [
          {
            purchased_by: {
              is: { name: { mode: insensitive, contains: $searchTerm } }
            }
          }
          {
            purchased_by: {
              is: { surname: { mode: insensitive, contains: $searchTerm } }
            }
          }
          { order_code: { mode: insensitive, contains: $searchTerm } }
          { order_external_code: { mode: insensitive, contains: $searchTerm } }
          { company_name: { mode: insensitive, contains: $searchTerm } }
          { invoice_code: { mode: insensitive, contains: $searchTerm } }
        ]
        AND: $filters
      }
      take: $take
      skip: $skip
    ) {
      id
      createdAt
      updatedAt
      order_status
      order_number
      order_code
      order_type
      total_price_confirmed
      order_items {
        id
        volume
      }
      confirmed_delivery_date
      order_external_code
      invoice_code
      company_name
      total_price
      purchased_by {
        id
        name
        surname
      }
    }
  }
`

export const CoreOrderData = gql`
  fragment CoreOrderData on Order {
    id
    createdAt
    updatedAt
    order_status
    order_locale
    order_number
    order_code
    order_external_code
    order_type
    invoice_code
    invoice_pdf_url
    discount_applied
    sub_total_price
    total_shipping_price
    total_price_without_VAT
    total_price
    zero_vat
    metadata
    company_name
    company_code
    vat_code
    confirmed_delivery_date
    preferred_delivery_date
    total_price_confirmed
    order_items {
      id
      createdAt
      volume
      reference
      status
      price
      sku
      quantity
      shipping_price
      delayed
      expected_delivery_date
      preferred_delivery_date
      delivery_date_history
      metadata
      order_index
      cart_item {
        id
        product_type
        fabric_code
        fabric_group_name
        fabric_color_name
        fabricCombination {
          fabricCombinationProfiles {
            name
            language
          }
        }
        cartItemFabrics {
          id
          fabric_code
          fabric_color_name
          fabric_group_name
          fabric_group {
            id
            code
            type
            fabric_group_profiles {
              language
              name
            }
          }
          fabric {
            id
            code
            color_name
            image {
              src
              src_thumbnail
            }
          }
          combination_option {
            fabricCombinationOptionProfiles {
              language
              name
            }
          }
        }
        product_container {
          id
          type
          single_product {
            images {
              src
              src_thumbnail
              display_order
            }
            product_profiles {
              name
              language
            }
          }
          advanced_product {
            id
            sku
            ean_code
            dimensions {
              id
              width
              height
              length
              radius
              weight
              seat_height
              seat_width
              seat_depth
              armrest_height
              armrest_width
              backrest_width
              fabric_usage
              corner_part_length
              mattress_width
              mattress_length
              mattress_height
              headboard_height
              headboard_width
              table_extended_lengh
              shade_height
              shade_radius
              lying_part_height
              leg_height
              mattress_overlay_height
              bedbox_height
              bedbox_width
              bedbox_length
              frame_thickness
              table_top_thickness
              table_leg_width
            }
            images {
              src
              src_thumbnail
              display_order
            }
            advanced_product_profiles {
              name
              language
            }
          }
        }
        advanced_product_type
        fabric_group {
          id
          type
          fabric_group_profiles {
            language
            name
          }
          fabric_price_category {
            id
            group_number
          }
        }
        fabric {
          id
          code
          image {
            src
            src_thumbnail
          }
        }
        selected_sofa_combinations
        additional_components_backup
        additional_components {
          id
          additionalComponentGroupId
          code
          additional_component_profiles {
            id
            name
            material_name
            description
            language
          }
          component_sku
          color {
            id
            hex
            background
          }
          image {
            id
            src
            src_thumbnail
          }
          additional_component_group {
            id
            code
            use_fabric_prices_for_components
            enable_custom_dimensions_for_components
            enabled_dimensions_in_group
            additional_component_group_profiles {
              id
              name
              description
              language
            }
          }
          dimensions {
            id
            width
            height
            length
            radius
            weight
            seat_height
            seat_width
            seat_depth
            armrest_height
            armrest_width
            backrest_width
            fabric_usage
            corner_part_length
            mattress_width
            mattress_length
            mattress_height
            headboard_height
            headboard_width
            table_extended_lengh
            shade_height
            shade_radius
            lying_part_height
            leg_height
            mattress_overlay_height
            bedbox_height
            bedbox_width
            bedbox_length
            frame_thickness
            table_top_thickness
            table_leg_width
          }
        }
      }
      shipping_method {
        id
      }
      invoice {
        id
      }
      order {
        id
      }
    }
    coupon {
      id
      fixed_price_coupon
      apply_on_top_of_other_discounts
      coupon_code
      fixed_price_discount
      percentage_discount
    }
    shipping_address {
      id
      phone_number
      country
      city
      postal_code
      state_region
      address_1
      address_2
      additional_phone_number
      comment
    }
    billing_address {
      id
      phone_number
      country
      city
      postal_code
      state_region
      address_1
      address_2
      additional_phone_number
      comment
    }
    purchased_subAccount {
      id
      name
    }
    purchased_customerAccount {
      id
      name
      email
      customer {
        name
        b2b_company_name
        role
      }
    }
    purchased_by {
      id
      name
      surname
      email
      default_phone_number
      language
      buying_as_company
      account_code
      b2b_company_name
      communication {
        sent_email_name
      }
      orders {
        id
      }
      invoices {
        id
      }
      customer_accounts {
        id
      }
    }
    payment_method {
      id
      payment_method_profiles {
        title
        language
      }
      image {
        src
      }
    }
    payment_transaction {
      id
    }
    order_notes
    proforma_invoice_link
  }
`

export const GET_ORDER_BY_ID = gql`
  query GET_ORDER_BY_ID($id: String!) {
    findUniqueOrder(where: { id: $id }) {
      ...CoreOrderData
    }
  }
  ${CoreOrderData}
`

export const GET_ORDER = gql`
  query GET_ORDER($id: String!) {
    findUniqueOrder(where: { id: $id }) {
      ...CoreOrderData
    }
  }
  ${CoreOrderData}
`

export const UPDATE_ORDER_STATUS = gql`
  mutation UPDATE_ORDER_STATUS(
    $where: OrderWhereUniqueInput!
    $order_status: OrderStatus!
    $order_notes: String
    $order_code: String
  ) {
    updateExistingOrderMutationV2(
      where: $where
      order_status: $order_status
      order_notes: $order_notes
      order_code: $order_code
    ) {
      id
      order_status
      order_notes
      order_code
      updatedAt
    }
  }
`

export const UPDATE_ORDER_EXTERNAL_CODE = gql`
  mutation UPDATE_ORDER_EXTERNAL_CODE(
    $where: OrderWhereUniqueInput!
    $order_external_code: String
  ) {
    updateExistingOrderMutationV2(
      where: $where
      order_external_code: $order_external_code
    ) {
      id
      order_external_code
      updatedAt
    }
  }
`

export const UPDATE_ORDER_CODE = gql`
  mutation UPDATE_ORDER_CODE(
    $where: OrderWhereUniqueInput!
    $order_code: String
  ) {
    updateExistingOrderMutationV2(where: $where, order_code: $order_code) {
      id
      order_code
      updatedAt
    }
  }
`

export const UPDATE_ORDER_NUMBER = gql`
  mutation UPDATE_ORDER_NUMBER(
    $where: OrderWhereUniqueInput!
    $order_number: Int
  ) {
    updateExistingOrderMutationV2(where: $where, order_number: $order_number) {
      id
      order_number
      updatedAt
    }
  }
`
